import { useSessionUnreadMessages } from '@app/api';

export const useSessionUnreadMessageByParticipation = (
  sessionId?: string,
  participationId?: string,
): number => {
  const { data: messages } = useSessionUnreadMessages(sessionId);
  if (!sessionId || !participationId) {
    return -1;
  }
  return messages
    ? messages.filter((message) => message.participationId === participationId)
        .length
    : -1;
};
